// src/dossiers/index.js — екран „Досиета": ЛИЦЕТО Е ДОСИЕТО (преработка по
// решение на Макс, 25.08.2026). Никакво междинно ниво „папка": разделът е
// списък хора на АКТИВНАТА ФИРМА — както „Фактури" е списък фактури на
// активната фирма. Клиентът (контрагент) е по избор — колона и филтър.
// Едно кликване: списък → човек (данни + сметки + PDF).

import { el, clear, $, field, input, row, clickableRow } from '../shared/dom.js';
import { dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { emptyState, panelH2, searchInput } from '../shared/ui.js';
import { openModal, closeModal, confirmDialog } from '../shared/modal.js';
import { whenFmt } from '../shared/audit.js';
import { contactPicker } from '../shared/pickers.js';
import { state, cq } from '../shared/state.js';

// Отвореното лице се помни между рендерите на рамката.
const _open = { personId: null };

// Отваря конкретно досие от друг екран (ползва го записът от калкулатора).
export function openDossierPerson(personId) {
  _open.personId = personId;
  window.CRM.state.view = 'dossiers';
  window.CRM.renderShell();
}

export async function view(page) {
  clear(page);
  if (!state().activeCompany) return window.CRM.needsCompany(page);
  if (_open.personId) return personView(page);
  return listView(page);
}

// ---------------- Списъкът: хората на активната фирма ----------------

async function listView(page) {
  let persons = [], contacts = [];
  // Контактите са помощни (етикетът „клиент") — отказът им не изпразва
  // списъка с досиетата (грешка от картата, 16.10.2026).
  const [dsR, conR] = await Promise.allSettled([api('/dossiers' + cq()), api('/contacts' + cq())]);
  if (dsR.status === 'fulfilled') persons = dsR.value || []; else toast(dsR.reason.message, true);
  if (conR.status === 'fulfilled') contacts = conR.value || [];
  const cName = (id) => { const c = contacts.find((x) => x.id === id); return c ? c.name : ''; };

  const panel = el('div', { class: 'panel' });
  panel.appendChild(el('div', { class: 'panel-head' }, ...panelH2('Досиета'),
    el('button', { class: 'btn sm', text: '+ Ново досие', onClick: () => personForm(null, contacts) })));

  if (!persons.length) {
    panel.appendChild(emptyState('▧', 'Още няма досиета. Досието е ЧОВЕК — въвеждате името му веднъж, а сметките от калкулаторите се трупат при него.', '+ Ново досие', () => personForm(null, contacts)));
    page.appendChild(panel);
    return;
  }

  let q = '';
  const tb = el('tbody');
  function draw() {
    clear(tb);
    persons
      .filter((p) => !q || (String(p.full_name || '') + ' ' + cName(p.contact_id) + ' ' + String(p.position || '')).toLowerCase().includes(q))
      .forEach((p) => {
        tb.appendChild(clickableRow(() => { _open.personId = p.id; window.CRM.renderView($('#page')); }, 'Отвори досие на ' + p.full_name,
          el('td', { style: 'font-weight:600' }, p.full_name),
          el('td', {}, cName(p.contact_id)),
          el('td', { class: 'hide-sm' }, p.position || ''),
          // ЕГН идва МАСКИРАНО от сървъра — пълното е само в детайла.
          el('td', { class: 'hide-sm' }, p.egn || ''),
          el('td', { class: 'hide-sm' }, dfmt(p.created_at))));
      });
  }
  panel.appendChild(el('div', { class: 'filter-bar' },
    searchInput({ placeholder: 'Търси по име, клиент или длъжност…', ariaLabel: 'Търсене на досие', onSearch: (v) => { q = v; draw(); } })));
  panel.appendChild(el('table', {}, el('thead', {}, el('tr', {},
    el('th', { scope: 'col', text: 'Име' }), el('th', { scope: 'col', text: 'Клиент' }),
    el('th', { scope: 'col', class: 'hide-sm', text: 'Длъжност' }),
    el('th', { scope: 'col', class: 'hide-sm', text: 'ЕГН' }), el('th', { scope: 'col', class: 'hide-sm', text: 'Добавено' }))), tb));
  draw();
  page.appendChild(panel);
}

// Формата за досие (лице): САМО името е задължително; клиентът е по избор
// етикет; всичко останало е прибрано в сгъваема секция.
function personForm(existing, contacts) {
  const p = existing || {};
  const contactHidden = el('input', { type: 'hidden', value: p.contact_id ? String(p.contact_id) : '' });
  const f = {
    full_name: input({ value: p.full_name || '', placeholder: 'Иван Петров Иванов' }),
    egn: input({ value: p.egn || '', placeholder: '10 цифри' }),
    position: input({ value: p.position || '', placeholder: 'напр. счетоводител' }),
    address: input({ value: p.address || '' }),
    id_card_no: input({ value: p.id_card_no || '' }),
    id_card_issued_by: input({ value: p.id_card_issued_by || '', placeholder: 'МВР…' }),
    id_card_issued_at: input({ value: p.id_card_issued_at || '', placeholder: 'гггг-мм-дд' }),
    iban: input({ value: p.iban || '', placeholder: 'BG…' }),
    phone: input({ value: p.phone || '' }),
    email: input({ type: 'email', value: p.email || '' }),
    note: el('textarea', {}, p.note || ''),
  };
  const save = async () => {
    if (!f.full_name.value.trim()) { toast('Въведете име — то е единственото задължително поле.', true); f.full_name.focus(); return; }
    const body = { company_id: state().activeCompany, contact_id: contactHidden.value || null };
    for (const k in f) body[k] = f[k].value;
    try {
      let saved;
      if (existing && existing.id) saved = await api('/dossiers/' + existing.id, { method: 'PUT', body: JSON.stringify(body) });
      else saved = await api('/dossiers', { method: 'POST', body: JSON.stringify(body) });
      closeModal();
      toast('Записано: ' + saved.full_name);
      _open.personId = saved.id;
      window.CRM.renderView($('#page'));
    } catch (e) { toast(e.message, true); }
  };
  openModal({
    title: existing && existing.id ? 'Досие: ' + existing.full_name : 'Ново досие',
    body: el('div', {},
      field('Име *', f.full_name),
      field('Клиент (по избор — за кого се отнася)', contactPicker(contacts || [], contactHidden)),
      el('details', { style: 'margin-top:10px' },
        el('summary', { style: 'cursor:pointer;font-weight:600;padding:4px 0', text: 'Допълнителни данни (по избор)' }),
        row(field('ЕГН', f.egn), field('Длъжност', f.position)),
        field('Адрес', f.address),
        row(field('Лична карта №', f.id_card_no), field('Издадена от', f.id_card_issued_by)),
        row(field('Издадена на', f.id_card_issued_at), field('IBAN', f.iban)),
        row(field('Телефон', f.phone), field('Имейл', f.email)),
        field('Бележка', f.note))),
    foot: el('div', {},
      el('button', { class: 'btn ghost', text: 'Отказ', onClick: closeModal }),
      el('button', { class: 'btn', text: 'Запази', onClick: save, style: 'margin-left:8px' })),
  });
}

// ---------------- Едно досие: данните на човека + сметките ----------------

async function personView(page) {
  let p = null, contacts = [];
  const [pR, cR] = await Promise.allSettled([api('/dossiers/' + _open.personId), api('/contacts' + cq())]);
  if (pR.status !== 'fulfilled') { toast(pR.reason.message, true); _open.personId = null; return listView(page); }
  p = pR.value;
  if (cR.status === 'fulfilled') contacts = cR.value || [];
  const client = contacts.find((c) => c.id === p.contact_id);

  const panel = el('div', { class: 'panel' });
  const back = el('button', { class: 'btn sm ghost', text: '← Всички досиета', onClick: () => { _open.personId = null; window.CRM.renderView($('#page')); } });
  panel.appendChild(el('div', { class: 'panel-head' }, back, ...panelH2(p.full_name),
    el('button', { class: 'btn sm ghost', text: 'Редактирай', onClick: () => personForm(p, contacts) }),
    el('button', { class: 'btn sm', text: 'PDF — цялото досие', onClick: () => window.open('/api/dossiers/' + p.id + '/pdf', '_blank') })));

  // Данните — само попълнените (в ДЕТАЙЛА ЕГН е пълно, това е нарочно).
  const FIELDS = [['egn', 'ЕГН'], ['position', 'Длъжност'], ['address', 'Адрес'],
    ['id_card_no', 'Лична карта №'], ['id_card_issued_by', 'Издадена от'], ['id_card_issued_at', 'Издадена на'],
    ['iban', 'IBAN'], ['phone', 'Телефон'], ['email', 'Имейл'], ['note', 'Бележка']];
  const filled = FIELDS.filter(([k]) => p[k]);
  const meta = el('div', { style: 'display:flex;flex-wrap:wrap;gap:6px 22px;font-size:13px;margin:2px 0 12px' });
  if (client) meta.appendChild(el('div', {}, el('span', { style: 'color:var(--muted)', text: 'Клиент: ' }), el('span', { style: 'font-weight:600', text: client.name })));
  filled.forEach(([k, label]) => meta.appendChild(el('div', {},
    el('span', { style: 'color:var(--muted)', text: label + ': ' }),
    el('span', { text: k === 'id_card_issued_at' ? dfmt(p[k]) : p[k] }))));
  if (meta.children.length) panel.appendChild(meta);

  const entries = p.entries || [];
  panel.appendChild(el('h4', { text: 'Изчисления (' + entries.length + ')', style: 'margin:8px 0 6px' }));
  if (!entries.length) {
    panel.appendChild(el('p', { style: 'color:var(--muted);font-size:13px', text: 'Още няма записани сметки. Отворете калкулатор „за лице" (Труд и осигуряване, Наем, чл. 55…) и натиснете „Запази в досие".' }));
  } else {
    const tb = el('tbody');
    entries.forEach((e) => {
      const bigLine = (e.result || []).find((r) => r.big) || (e.result || [])[0] || {};
      const delBtn = el('button', { class: 'btn sm danger', text: '×', 'aria-label': 'Изтрий сметката ' + (e.calc_label || ''), onClick: async (ev) => {
        ev.stopPropagation();
        if (!(await confirmDialog('Да изтрия ли тази сметка от досието?', { okText: 'Изтрий', danger: true }))) return;
        try { await api('/dossiers/' + p.id + '/entries/' + e.id, { method: 'DELETE' }); toast('Изтрито.'); window.CRM.renderView($('#page')); }
        catch (err) { toast(err.message, true); }
      } });
      tb.appendChild(clickableRow(() => window.open('/api/dossiers/entry/' + e.id + '/pdf', '_blank'), 'Отвори PDF на ' + (e.calc_label || 'сметката'),
        el('td', { style: 'font-weight:600' }, e.calc_label || e.calc_key),
        el('td', {}, String(bigLine.label || '')),
        el('td', { class: 'num' }, typeof bigLine.value === 'number' ? bigLine.value.toFixed(2).replace('.', ',') + ' €' : String(bigLine.value || '')),
        el('td', { class: 'hide-sm' }, whenFmt(e.created_at) + (e.created_by ? ' · ' + e.created_by : '')),
        el('td', { style: 'width:34px' }, delBtn)));
    });
    panel.appendChild(el('table', {}, el('thead', {}, el('tr', {},
      el('th', { scope: 'col', text: 'Сметка' }), el('th', { scope: 'col', text: 'Резултат' }),
      el('th', { scope: 'col', class: 'num', text: 'Стойност' }), el('th', { scope: 'col', class: 'hide-sm', text: 'Кога / кой' }), el('th'))), tb));
    panel.appendChild(el('p', { style: 'color:var(--muted);font-size:12px;margin-top:6px', text: 'Клик върху ред отваря PDF на съответната справка.' }));
  }

  if (state().user && state().user.role === 'admin') {
    panel.appendChild(el('div', { style: 'margin-top:12px' },
      el('button', { class: 'btn sm danger', text: 'Изтрий досието', onClick: async () => {
        if (!(await confirmDialog('Да изтрия ли досието и всичките му сметки?', { okText: 'Изтрий', danger: true }))) return;
        try { await api('/dossiers/' + p.id, { method: 'DELETE' }); toast('Изтрито.'); _open.personId = null; window.CRM.renderView($('#page')); }
        catch (e) { toast(e.message, true); }
      } })));
  }
  page.appendChild(panel);
}
